"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalPages = totalPages;
function totalPages(total, limit) {
    return Math.max(1, Math.ceil(total / limit));
}
//# sourceMappingURL=pagination.js.map